// extracted by mini-css-extract-plugin
export default {"addTextH2":"_3edDg8vFGzei-eYcCRfFmX"};